import React from 'react';
import './LandingPage.css';
import sheetMapIcon from '../icons/SheetMapIcon.png';
import qbMapIcon from '../icons/QBMapIcon.png';
import geocodingIcon from '../icons/GeocodingIcon.png';

function LandingPage({ isAuthenticated, handleAuthenticate, hasSheetsScope }) {
  const tools = [
    {
      id: 'sheet-mapper',
      name: 'Google Sheet Mapper',
      description: 'Load, visualize, and edit Google Sheets data on an interactive map',
      icon: 'sheet-icon',
      status: 'active',
      route: '/sheet-mapper',
      requiresAuth: true,
      requiresSheets: true,
    },
    {
      id: 'geocoding',
      name: 'Bulk Geocoding Tool',
      description: 'Geocode addresses from Google Sheets to latitude/longitude coordinates',
      icon: 'geocoding-icon',
      status: 'active',
      route: '/geocoding',
      requiresAuth: true,
      requiresSheets: true,
    },
    {
      id: 'quickbase-mapper',
      name: 'QuickBase Mapper',
      description: 'Map and visualize QuickBase records on an interactive map',
      icon: 'qb-icon',
      status: 'active',
      route: '/quickbase-mapper',
      requiresAuth: true,
      badge: 'Beta'
    },
    {
      id: 'coordinator-map',
      name: 'Coordinator Map',
      description: 'View active tickets and field reps on an interactive map with filtering',
      icon: '🗺️',
      status: 'active',
      route: '/coordinator-map',
      requiresAuth: true
    }
  ];

  const renderAction = (tool) => {
    if (tool.status !== 'active') {
      return <div className="tool-status-badge">Coming Soon</div>;
    }

    if (tool.requiresAuth && !isAuthenticated) {
      // Sheet tools: sign in with Sheets in one consent step
      const onClick = tool.requiresSheets
        ? () => handleAuthenticate({ scopes: ['sheets'], returnPath: tool.route })
        : () => handleAuthenticate({ returnPath: tool.route });
      return (
        <button onClick={onClick} className="tool-button">
          Sign In
        </button>
      );
    }

    if (tool.requiresSheets && !hasSheetsScope) {
      return (
        <button
          onClick={() => handleAuthenticate({ scopes: ['sheets'], returnPath: tool.route })}
          className="tool-button"
        >
          Allow Sheets & Launch
        </button>
      );
    }

    return (
      <a href={tool.route} className="tool-button">
        Launch
      </a>
    );
  };

  return (
    <div className="landing-page">
      <div className="hero-section">
        <h1 className="hero-title">SSN GEMS</h1>
        <p className="hero-subtitle">Site Services Now! - Geo-mapping Editing & Management System</p>
      </div>

      <div className="tools-grid">
        {tools.map(tool => (
          <div key={tool.id} className={`tool-card ${tool.status}`}>
            <div className="tool-icon">
              {tool.icon === 'sheet-icon' ? (
                <img src={sheetMapIcon} alt="" className="tool-icon-img" />
              ) : tool.icon === 'geocoding-icon' ? (
                <img src={geocodingIcon} alt="" className="tool-icon-img" />
              ) : tool.icon === 'qb-icon' ? (
                <img src={qbMapIcon} alt="" className="tool-icon-img" />
              ) : (
                tool.icon
              )}
            </div>
            <h3 className="tool-name">
              {tool.name}
              {tool.badge && <span className="tool-badge-beta">{tool.badge}</span>}
            </h3>
            <p className="tool-description">{tool.description}</p>
            {renderAction(tool)}
          </div>
        ))}
      </div>

    </div>
  );
}

export default LandingPage;
